import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaCar, FaClock, FaDollarSign, FaStar } from 'react-icons/fa';
import './Features.css';

const Features = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const features = [
    {
      icon: <FaCar />,
      title: 'Easy Booking',
      description: 'Book car wash services in just a few taps'
    },
    {
      icon: <FaClock />,
      title: 'Quick Service',
      description: 'Professional service in 30 minutes or less'
    },
    {
      icon: <FaDollarSign />,
      title: 'Best Prices',
      description: 'Competitive pricing with no hidden charges'
    },
    {
      icon: <FaStar />,
      title: 'Quality Guaranteed',
      description: 'Satisfaction guaranteed or your money back'
    }
  ];

  return (
    <section id="features" className="features section" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Why Choose SyarTech?</h2>
          <p>Experience the future of car care with our innovative features</p>
        </motion.div>
        
        <motion.div 
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {features.map((feature, index) => (
            <motion.div 
              key={index} 
              className="feature-card"
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05,
                transition: { duration: 0.2 }
              }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;